import { combineReducers } from "redux";

import formProperties from './FormPropertyReducer/FormPropertyReducer'
import formData from './FormDataReducers/RootFormDataReducer'
import formServices from './FormServiceReducers/FormServiceRootReducer'

export default combineReducers({
    formProperties,
    formData,
    formServices
});